/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
*/

import { TenantService } from '@src/app/shared/tenant.service';
import { MoaChart } from "@src/app/modules/agent/agent-dashboard-page/MoaChart";

export class MoaAllChart extends MoaChart {
    title = "All Actions";
    dataUrl = TenantService.ajaxPath + 'agent/dashboard/moaAll';

    getRouteParamsDone(i: { plannedDate: string }) {
        return { plannedDate: i.plannedDate, done: 1, _sort: 'plannedDate' };
    }

    getRouteParamsTodo(i: { plannedDate: string }) {
        return { plannedDate: i.plannedDate, done: 0, _sort: 'plannedDate' }
    }
}
